$('.acc .acc__head').click(function (e) {
	e.preventDefault()
	var $currentAcc = $(this).parent().parent('.acc')
	var $currentAccItem = $(this).parent('.acc__item')

	$('.acc__item', $currentAcc).not($currentAccItem).removeClass('acc__item--isopen')
	$('.acc__item', $currentAcc).not($currentAccItem).find('.acc__content').stop().slideUp()

	$currentAccItem.toggleClass('acc__item--isopen')

	$('.acc__content', $currentAccItem).stop().slideToggle()
})
